









































import {
  defineComponent,
  computed,
  onBeforeMount,
  ref,
  watch,
} from "@vue/composition-api";
import {
  useStore,
  useDogService,
  useRouter,
  useUserService,
} from "@/composables/providers";
import { DogTraining, DogTrainerTableDisplayBody, Dog, User } from "@/store";
import { DogGetters, DogActions } from "@/store/dog";
import DogTrainingsTable from "@/components/tables/DogTraining.vue";
import { SessionGetters } from "@/store/session";

export default defineComponent({
  name: "DogTrainingsList",
  components: {
    DogTrainingsTable,
  },
  setup() {
    const store = useStore();
    const service = useDogService();
    const userService = useUserService();
    const router = useRouter();
    const id = computed<string>(() => router.currentRoute.params["id"] || "");
    const dashboard = computed<boolean>(() =>
      router.currentRoute.name
        ? router.currentRoute.name?.toLocaleLowerCase().startsWith("dashboard")
        : false
    );
    const isStaffOrHigher = computed<boolean>(
      () => store.getters[SessionGetters.IS_STAFF_OR_HIGHER]
    );
    const currentUser = computed<User>(
      () => store.getters[SessionGetters.USER]
    );
    const trainer = computed<User>(
      () => store.getters[DogGetters.CURRENT_TRAINER]
    );
    const trainerIsUser = computed<boolean>(
      () => trainer.value?.id === currentUser.value?.id
    );

    const trainings = computed<DogTrainerTableDisplayBody[]>(
      () => store.getters[DogGetters.CURRENT_TRAINER_TRAININGS]
    );

    const trainingsToDisplay = ref<DogTrainerTableDisplayBody[]>([]);

    watch(trainings, () => (trainingsToDisplay.value = trainings.value));
    const loading = ref<boolean>(store.getters[DogGetters.LOADING]);

    onBeforeMount(async () => {
      await Promise.all([
        await store.dispatch(DogActions.SELECT_CURRENT_TRAINER, {
          id: dashboard.value ? currentUser.value?.id : id.value,
          service: userService,
        }),
        await store.dispatch(DogActions.LIST, { service }),
      ]);
    });

    async function deleteTraining($event: DogTrainerTableDisplayBody) {
      trainingsToDisplay.value = trainingsToDisplay.value.filter(
        (training) => training.id !== $event.id
      );
      const body: Partial<Dog> = {};
      body.dogTrainings = trainingsToDisplay.value.map((training) => {
        return {
          id: training.id,
          publicAccessTraining: training.publicAccessTraining,
          regularTraining: training.regularTraining,
          date: training.date,
          user: training.user,
        };
      }) as DogTraining[];

      if (isStaffOrHigher.value) {
        await store.dispatch(DogActions.UPDATE, {
          id: $event.dogId,
          body,
          service,
        });
      } else if (trainerIsUser.value) {
        await store.dispatch(DogActions.DELETE_TRAINING, {
          id: $event.dogId,
          trainingId: $event.id,
          service,
        });
      }
    }

    async function navigateBack() {
      await router.go(-1);
    }

    return {
      loading,
      router,
      trainingsToDisplay,
      deleteTraining,
      trainings,
      navigateBack,
      dashboard,
      trainerIsUser,
    };
  },
});
